/** Hairline gradient between home sections (design.xml "Section Flow"). */
export function SectionDivider() {
  return <div aria-hidden="true" className="divider-gradient mx-auto h-px w-full max-w-6xl" />;
}
